/* eslint-disable complexity */
import React, { CSSProperties, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import clsx from 'clsx';

import Icon from 'carbon-react/lib/components/icon';

import { LinkedSheetData } from '../../types';
import { SheetSyncStatus } from '../../../hooks/use-sheets-sync-status/use-sheets-sync-status';

import styles from './sync-template-list.scss';

interface LinkedTemplateListProps {
  className?: string;
  sheets: LinkedSheetData[];
  style?: CSSProperties;
  syncingIds?: string[];
  syncResults?: Record<string, boolean>;
  syncStatusResults?: Record<string, SheetSyncStatus>;
}

export const SyncTemplateList = ({
  className,
  sheets,
  style,
  syncingIds = [],
  syncResults = {},
  syncStatusResults = {}
}: LinkedTemplateListProps) => {
  const getRowContent = (item: LinkedSheetData) => {
    let content: ReactNode;
    const syncStatusResult = syncStatusResults[item.forecastId];

    const isSyncing = syncingIds.includes(item.forecastId);
    const isSynced = syncResults[item.forecastId] === true;
    const isSyncFailed = syncResults[item.forecastId] === false;
    const isNotAllowedMismatch = !syncStatusResult?.allowImport && syncStatusResult?.incorrectSheetsToImport.length > 0;
    const isNotAllowedNoTabs = !syncStatusResult?.allowImport && syncStatusResult?.incorrectSheetsToImport.length === 0;
    // const isSyncError = item.token?.hasToken === false;

    if (isSyncing) {
      content = <Icon type="sync" />;
    } else if (isSynced) {
      content = <FormattedMessage id="common.synced" defaultMessage="Synced" />;
    } else if (isSyncFailed) {
      content = <FormattedMessage id="common.sync_error" defaultMessage="Sync error" />;
    } else if (isNotAllowedMismatch) {
      content = (
        <FormattedMessage
          id="import.sync_tabs_mismatch"
          defaultMessage="Issue with tab names provided in master file."
        />
      );
    } else if (isNotAllowedNoTabs) {
      content = <FormattedMessage id="import.no_tabs" defaultMessage="No sheets / tabs available to import." />;
    } else {
      content = <FormattedMessage id="import.ready_to_sync" defaultMessage="Ready to sync" />;
    }
    return <td>{content}</td>;
  };

  return (
    <table className={clsx(styles.table, className)} style={style} data-testid="sync-template-list">
      <tbody>
        {sheets.map(item => (
          <tr key={item.sheetId}>
            <td>
              <strong>{item.entity?.name}</strong>
            </td>
            {getRowContent(item)}
          </tr>
        ))}
      </tbody>
    </table>
  );
};
